import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import UserMenu from '../../../../containers/UserMenu';

import { hideAboveSM, srOnly } from '../../../../base-styles/mixins.module.css';
import {
  close,
  item,
  itemHideMD,
  link as solidLink,
  list,
  nav,
  search,
  searchLink,
  transparentLink,
  transparentSearchLink,
  transparentUser,
  user,
} from './styles.module.css';

/**
 * Header menu navigation presentational component.
 * Combines top level navigation links and user menu component.
 */
const HeaderMenuNav = ({
  className,
  countryCode,
  expanded,
  loggedIn,
  onCloseClick,
  onLinkClick,
  onSearchLinkClick,
  profile,
  transparent,
  dispatch, // eslint-disable-line
  ...domProps
}) => {
  const linkStyle = transparent ? transparentLink : solidLink;
  return (
    <nav className={`${nav} ${className}`} {...domProps} aria-expanded={expanded}>
      <ul className={list}>
        <li className={search}>
          <a
            className={transparent ? transparentSearchLink : searchLink}
            onClick={() => { onSearchLinkClick(); onLinkClick(); }}
          >
            {'Search Events'}
          </a>
        </li>
        <li className={[item, hideAboveSM].join(' ')}>
          <Link className={linkStyle} onClick={onLinkClick} to="/">{'Home'}</Link>
        </li>
        <li className={itemHideMD}>
          <a className={linkStyle} href={countryCode === 'US' ? '/organizers/' : '/organisers/'} >
            {'Race Organisers'}
          </a>
        </li>
        <li className={hideAboveSM}>
          <Link className={linkStyle} onClick={onLinkClick} to="/profile">
            {'My Profile'}
          </Link>
        </li>
        <li className={hideAboveSM}>
          <Link className={linkStyle} onClick={onLinkClick} to="/profile/settings">
            {'Edit Settings'}
          </Link>
        </li>
        {!loggedIn && (
          <li className={hideAboveSM}>
            <Link className={linkStyle} onClick={onLinkClick} to="/login">
              {'Sign Up or Log In'}
            </Link>
          </li>
        )}
        {loggedIn && (
          <li className={hideAboveSM}>
            <Link className={linkStyle} onClick={onLinkClick} to="/logout">
              {'Log Out'}
            </Link>
          </li>
        )}
      </ul>

      <UserMenu
        className={transparent ? transparentUser : user}
        onLinkClick={onLinkClick}
        transparent={transparent}
      />

      {expanded &&
        <button className={close} onClick={onCloseClick}>
          <i className="fa fa-close" aria-hidden="true" />
          <span className={srOnly}>Close</span>
        </button>}
    </nav>
  );
};

HeaderMenuNav.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /*
   * The code representing the country in which the session is taking place
   */
  countryCode: PropTypes.string,
  /**
   * Boolean whether to use expanded styles.
   */
  expanded: PropTypes.bool,
  /**
   * Boolean describing user autenticated state.
   */
  loggedIn: PropTypes.bool,
  /**
   * Function called on close click.
   */
  onCloseClick: PropTypes.func,
  /**
   * Function called on link click.
   */
  onLinkClick: PropTypes.func,
  /**
   * TODO:
   */
  onSearchLinkClick: PropTypes.func,
  /**
   * Normalized user profile object, when user is logged in
   */
  profile: PropTypes.shape(),
  /**
   * Boolean whether to use transparent styles.
   */
  transparent: PropTypes.bool,
};

HeaderMenuNav.defaultProps = {
  className: '',
  countryCode: undefined,
  expanded: true,
  loggedIn: false,
  onCloseClick: () => {},
  onLinkClick: () => {},
  onSearchLinkClick: () => {},
  profile: null,
  transparent: false,
};

const mapStateToProps = state => ({
  countryCode: state.countryCode,
});

// Wrap in [react-redux connect](https://github.com/reactjs/react-redux/blob/master/docs/api.md#connect)
const HeaderMenuNavRedux = connect(mapStateToProps)(HeaderMenuNav); // eslint-disable-line no-class-assign, max-len

export default HeaderMenuNavRedux;



// WEBPACK FOOTER //
// ./app/src/components/HeaderMenu/components/HeaderMenuNav/index.jsx